import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack,
  FDTitleText,
  FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import metaOverrideSet from '../metaOverrideSet';
import ESPMatchLayout from './ESPMatchLayout';

const ESPMatchCollectionForm = ({
  resource,
  attrName,
  handleAdd,
  handleRemove,
}) => {
  return (
    <FDStack direction="column">
      <FDStack direction="row" spacing={1} alignItems="center">
        <FDTitleText value={resource.metaField(attrName).attr('prompt')} size={'lg'} />
        <FDStack direction="row">
          <FDSecondaryActionIconButton
            icon="removeCircle"
            onClick={handleRemove}
            disabled={resource.attr(attrName).resources().length() <= 1}
          />
          <FDSecondaryActionIconButton
            icon="addCircle"
            onClick={handleAdd(attrName)}
            disabled={resource.attr(attrName).resources().length() >= resource.metaField(attrName).attr('max')}
          />
        </FDStack>
      </FDStack>
      <MetaCollectionFormInline
        padding="none"
        collection={resource.attr(attrName)}
        FormProps={{
          layout: ESPMatchLayout,
          noIndividualSubmitButtons: true,
        }}
        metaOverrideSet={metaOverrideSet}
      />
    </FDStack>
  );
};

ESPMatchCollectionForm.propTypes = {
  resource: PropTypes.object.isRequired,
  attrName: PropTypes.string.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
};

export default ESPMatchCollectionForm;
